import cn from 'classnames';
import withStyles, {
  createStyles,
  WithStyles,
} from 'raydiant-elements/core/withStyles';
import { Theme } from 'raydiant-elements/theme';
import * as React from 'react';
import Media from './Media';

interface ScreenFrameProps extends WithStyles<typeof styles> {
  align?: 'center' | 'right';
  children?: React.ReactNode;
}

const ScreenFrame: React.FunctionComponent<ScreenFrameProps> = ({
  align = 'center',
  children,
  classes,
}) => (
  <Media aspectRatio={[16, 9]}>
    <div
      className={cn(
        classes.contents,
        align === 'right' && classes.contentsRight
      )}
    >
      <div className={classes.contentsInner}>{children}</div>
    </div>
    <img
      className={cn(classes.frame, align === 'right' && classes.frameRight)}
      src={require('../assets/images/tv-screen-frame.png')}
    />
  </Media>
);

const styles = (theme: Theme) =>
  createStyles({
    frame: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      boxShadow: theme.shadows[8],
    },
    frameRight: {
      left: 'auto',
      transform: 'none',
      right: 0,
    },
    contents: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: '#000',
    },
    contentsInner: {
      position: 'absolute',
      top: '2%',
      left: '1%',
      width: '98%',
      height: '96%',

      '& > *': {
        width: '100%',
        height: '100%',
      },
    },
    contentsRight: {
      left: 'auto',
      right: 0,
    },
  });

export default withStyles(styles)(ScreenFrame);
